export default {"src":"/_next/static/media/blue-shield.5b70075f.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};